import { BaseFormula } from "../BaseFormula";
import { CalculationResult } from "../CalculationResult";
import { ChangeType } from "../ChangeType";
import { CostData } from "../CostData";

export class Formula_RegressionResidual extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { threshold: number }, show_new_cost: boolean): CalculationResult
    {
        let err = this.checkLength(data, 2, show_new_cost);
        if (err)
            return err;

        data = [...data, value];
        let x = Array.from({ length: data.length }, (_, i) => i);
        let y = data;

        let length = x.length;
        let sum_of_x = x.reduce((a, b) => a + b, 0);
        let sum_of_y = y.reduce((a, b) => a + b.amount, 0);
        let sum_of_xy = x.reduce((a, b, i) => a + b * y[i].amount, 0);
        let sum_of_x2 = x.reduce((a, b) => a + b * b, 0);

        let slope = (length * sum_of_xy - sum_of_x * sum_of_y) / (length * sum_of_x2 - sum_of_x * sum_of_x);
        let intercept = (sum_of_y - slope * sum_of_x) / length;

        let residuals = y.map((yi, i) => yi.amount - (slope * i + intercept));
        let mean_residual = residuals.reduce((a, b) => a + b, 0) / length;
        let std_residual = Math.sqrt(residuals.reduce((a, b) => a + Math.pow(b - mean_residual, 2), 0) / length);

        if (std_residual === 0)
            return {
                value: null,
                reason: `Standard Deviation is zero.`,
                values: { length, sum_of_x, sum_of_y, sum_of_xy, sum_of_x2, slope, intercept, mean_residual, std_residual }
            };

        let last_residual = residuals[residuals.length - 1];
        let z_score = (last_residual - mean_residual) / std_residual;

        err = this.checkChnage(change, z_score, { length, sum_of_x, sum_of_y, sum_of_xy, sum_of_x2, slope, intercept, mean_residual, std_residual, last_residual, z_score });
        if (err)
            return err;

        return {
            value: Math.abs(z_score) > parameters.threshold,
            values: { length, sum_of_x, sum_of_y, sum_of_xy, sum_of_x2, slope, intercept, mean_residual, std_residual, last_residual, z_score }
        };
    }
} 